/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, August 2020
 */

import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children?: React.ReactNode;
};

const BodyPortal = ({ children }: Props) => {
  const elementRef = useRef(document.createElement('div'));
  useEffect(() => {
    const element = elementRef.current;
    document.body.appendChild(element);
    return () => {
      document.body.removeChild(element);
    };
  });

  return ReactDOM.createPortal(children, elementRef.current);
};

export default BodyPortal;
